// extracted by mini-css-extract-plugin
export default {"container":"gkDa34xvrND78rewgCRD","title":"Ue_Hm4eXgpKxO6qF4O1a","answer":"wVsYSvUSFrKi8ACmK_Dz"};